import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * Ancienne URL de réservation, nue et non authentifiée.
 *
 * Elle est remplacée par la page publique de la proposition, qui vérifie
 * l'accès avant d'ouvrir quoi que ce soit. Les liens déjà partis (mails,
 * favoris) y atterrissent : la page leur demandera le nom du client ou d'un
 * voyageur, plutôt que de leur répondre 404.
 */
export const Route = createFileRoute('/_blue_header/reservation/$estimateResponseId')({
  beforeLoad: ({ params }) => {
    throw redirect({
      params: { estimateResponseId: params.estimateResponseId },
      replace: true,
      to: '/devis/$estimateResponseId',
    })
  },
})
